<template>
	<div id="app">
		<!-- <img src="./assets/logo.png"> -->
		<router-view v-if="isRouterAlive" />
	</div>
</template>

<script>
	export default {
		name: 'App',
		provide() {
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isRouterAlive: true
			}
		},
		methods: {
			reload() {
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
			}
		},
		created() {
			// 在页面加载时读取localStorage里的状态信息
			if (localStorage.getItem('userMsg')) this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(
				localStorage.getItem('userMsg'))))
			// 在页面刷新时将vuex里的信息保存到localStorage里
			window.addEventListener('beforeunload', () => {
				localStorage.setItem('userMsg', JSON.stringify(this.$store.state))
			})
		}
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		height: 100%;
		/* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
	}

	.el-date-picker table {
		table-layout: auto !important;
		width: 100%;
	}

	.el-date-range-picker table {
		table-layout: auto !important;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue